var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsolvancy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47.75,
    fill: "#FEFEFE",
    stroke: "#1C1C1C",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4118 27.658L28.6243 24.4706L70.5882 66.4345L67.4008 69.6471L58.1898 60.4361C56.6337 62.1176 54.3749 63.498 51.7647 64.1757V69.6471H44.2353V64.1757C39.1404 62.8957 35.451 59.0808 35.451 54.5882H40.4706C40.4706 57.2988 43.909 59.6078 48 59.6078C50.8361 59.6078 53.371 58.5035 54.651 56.8972L47.1969 49.4431C41.9263 48.1129 35.451 46.4314 35.451 39.5294C35.451 38.9522 35.451 38.4 35.6267 37.8729L25.4118 27.658ZM44.2353 29.942V24.4706H51.7647V29.942C56.8596 31.222 60.549 35.0369 60.549 39.5294H55.5294C55.5294 36.8188 52.091 34.5098 48 34.5098C47.0714 34.5098 46.1929 34.6353 45.3647 34.8361L41.4745 30.9459L44.2353 29.942Z",
    fill: "#1C1C1C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsolvancy);
export default __webpack_public_path__ + "static/media/Insolvancy.985e82c1f7047c0ef9aedd42d1feecbc.svg";
export { ForwardRef as ReactComponent };